// Country ID
export const COUNTRY_ID_SINGAPORE = 183;
export const COUNTRY_ID_VIETNAM = 231;
export const COUNTRY_ID_INDONESIA = 98;

// Country Abbr
export const COUNTRY_ABBR_SINGAPORE = 'SG';
export const COUNTRY_ABBR_VIETNAM = 'VN';
export const COUNTRY_ABBR_INDONESIA = 'ID';
